import apiCalls from "../api/apiCalls";
const USEER_INFO = "userInfo";
const UPDATE_DOC_REQUEST = "updateDocRequest";
const FETCH_TRACK_AUDITLOGS = "fetchtrackauditlogs";
const CLEAR_USER_INFO = "clearUserInfo";
const UPDATE_TWOFACTOR = "updatetwofactor";
const UPDATE_KYCDATA="updateKycData"
const userInfo = (payload) => {
    return {
        type: USEER_INFO,
        payload
    }
};
const fetchtrackauditlogs = (payload) => {
    return {
        type: FETCH_TRACK_AUDITLOGS,
        payload
    }
};
const updateDocRequest = (payload) => {
    return {
        type: UPDATE_DOC_REQUEST,
        payload
    }
};
const updatetwofactor = (payload) => {
    return {
        type: UPDATE_TWOFACTOR,
        payload
    }
};
const updateKycData=(payload)=>{
    return {
        type: UPDATE_KYCDATA,
        payload
    }
}
const clearUserInfo = () => {
    return { type: CLEAR_USER_INFO, payload: null }
}
const getmemeberInfo = (userid) => {
    return async (dispatch) => {
        let twofa;
        apiCalls.getMember(userid).then((res) => {
            if (res.ok) {
                res.data.twofactorVerified = twofa;
                dispatch(userInfo(res.data));
            }
        });
    }
}
const getkycData=(tenanatId)=>{
    return async (dispatch) => {
        apiCalls.getKYCinfo(tenanatId).then((res) => {
            if (res.ok) {
                dispatch(updateKycData(res.data));
            }
        });
    }
}
let initialState = {
    userProfileInfo: null,
    trackAuditLogData: {},
    twoFA: { loading: true, isEnabled: false },kycData:null
};
const UserConfig = (state = initialState, action) => {
    switch (action.type) {
        case USEER_INFO:
            state = { ...state, userProfileInfo: action.payload }
            return state;
        case UPDATE_DOC_REQUEST:
            state = { ...state, userProfileInfo: { ...state.userProfileInfo, isDocsRequested: action.payload } }
            return state;
        case UPDATE_TWOFACTOR:
            if (typeof action.payload == "boolean")
                state = { ...state, userProfileInfo: { ...state.userProfileInfo, twofactorVerified: action.payload } }
            else
                state = { ...state, twoFA: { loading: action.payload.loading, isEnabled: action.payload.isEnabled } }
            return state;
        case FETCH_TRACK_AUDITLOGS:
            state = { ...state, trackAuditLogData: action.payload }
            return state;
        case CLEAR_USER_INFO:
            state = { userProfileInfo: null, trackAuditLogData: {} };
            return state;
            case UPDATE_KYCDATA:
                state = { ...state, kycData: action.payload }
                return state;  
        default:
            return state;
    }
}

export default UserConfig;
export { userInfo, getmemeberInfo, updateDocRequest, fetchtrackauditlogs, clearUserInfo, updatetwofactor,getkycData };